const breakpoint = {
  mobile: 0,
  desktopSmall: 997,
  desktop: 1240,
}

export const devices = {
  mobile: `(min-width: ${breakpoint.mobile}px) and (max-width: ${breakpoint.desktopSmall - 1}px)`,
  desktopSmall: `(min-width: ${breakpoint.desktopSmall}px) and (max-width: ${breakpoint.desktop - 1}px)`,
  desktop: `(min-width: ${breakpoint.desktop}px)`,
}
